module.exports = __webpack_public_path__ + "img/cameraPlaceholder.c65d718b.png";